export default __webpack_public_path__ + "static/media/park.709a6c8d.svg";